import React from 'react';
import { Box } from '@mui/material';
import SatelliteDataReportSubHeader from '../../../../components/SatelliteDataReport/SatelliteDataReportSubHeader';
import AMIrrigationPlanner from '../../../../components/SatelliteCharts/AMIrrigationPlanner';
import AMSoilMoistureGraph2 from '../../../../components/SatelliteCharts/AMSoilMoistureGraph2';
import CropGrowthGraph from '../../../../components/SatelliteCharts/CropGrowthGraph';

const AmReportSectionBox = ({ title, farmId, sectionName, accessKey, id }) => {
  return (
    <Box
      sx={{
        breakInside: 'avoid',
        pageBreakInside: 'avoid',
        '@media print': {
          pageBreakInside: 'avoid',
          marginBottom: '3mm',
        },
      }}
      id={id}
    >
      <SatelliteDataReportSubHeader text={title} />
      <Box
        sx={{
          px: 3,
          py: 1.5,
          display: 'flex',
          justifyContent: 'center',
          '@media print': {
            padding: '2mm',
          },
        }}
      >
        <Box
          sx={{
            bgcolor: '#ffffff',
            boxShadow: '#C3BCBC40',
            pt: 1.5,
            width: '100%',
            maxWidth: '520px',
            '@media print': {
              width: '100%',
              maxWidth: '180mm',
              paddingTop: '2mm',
              boxShadow: 'none',
              backgroundColor: '#ffffff !important',
            },
          }}
        >
          {sectionName === 'irrigation_planner' && (
            <AMIrrigationPlanner farmId={farmId} accessKey={accessKey} />
          )}
          {sectionName === 'soil_moisture_stats' && (
            <AMSoilMoistureGraph2 farmId={farmId} accessKey={accessKey} />
          )}
          {sectionName === 'crop_growth_stats' && (
            <CropGrowthGraph farmId={farmId} accessKey={accessKey} />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default AmReportSectionBox;
